import React from "react";
import MultiOptionFilter from "./MultiOptionFilter";
import CustomCheckbox from "src/core/common/components/elements/checkbox/CustomCheckbox";
import {FilterOption} from "./FilterOption";
import useSite from "src/core/sites/hooks/useSite";

function TagFilter({
  onChange,
  value,
  name,
  options,
  disabled,
  filtersCounter,
  noOptionsText,
  checkedMarkColor,
}) {
  const site = useSite();
  const collapseTagFilters = site.getUiConfiguration().filters.collapseTagFilters;
  return (
    <MultiOptionFilter
      onChange={onChange}
      value={value}
      name={name}
      color={checkedMarkColor}
      options={options || []}
      disabled={disabled}
      renderOption={renderTagOption}
      filtersCounter={filtersCounter}
      noOptionsText={noOptionsText}
      collapseTagFilters={collapseTagFilters}
    />
  );
}

function renderTagOption(option, onChange, value = "", disabled, color) {
  const tagName = option.getName();
  const tagTitle = option.getTitle();
  const tagCount = option.getCount();
  const allTypes = value ? value.split(",") : [];
  const checked = allTypes.indexOf(tagName) > -1;
  function toggleOption(e) {
    e.preventDefault();
    if (checked) {
      onChange(allTypes.filter((t) => t !== tagName).join(","));
    } else {
      onChange([...allTypes, tagName].join(","));
    }
  }

  return (
    <FilterOption onClick={toggleOption} disabled={disabled}>
      <CustomCheckbox
        checked={checked}
        name={option.value}
        value={option.value}
        color={color}
        onChange={() => {}}
        id={tagName}
      />
      <label htmlFor={tagName}>
        {tagTitle || tagName} ({tagCount})
      </label>
    </FilterOption>
  );
}

export default TagFilter;
